@if (loading) {
  <app-admin-state-panel
    mode="loading"
    titleKey="COMMON.LOADING"
    descriptionKey="ADMIN.USERS.DETAIL.LOADING"
  ></app-admin-state-panel>
} @else if (hasError || !user) {
  <app-admin-state-panel
    mode="error"
    titleKey="COMMON.ERROR"
    descriptionKey="ADMIN.USERS.DETAIL.ERROR"
    [showRetry]="true"
    (retry)="load()"
  ></app-admin-state-panel>
} @else {
  <app-admin-form-layout
    titleKey="ADMIN.USERS.DETAIL.EMPLOYEE.FORM_TITLE"
    descriptionKey="ADMIN.USERS.DETAIL.EMPLOYEE.FORM_DESCRIPTION"
  >
    <app-form-user
      [payload]="user"
      [showIntro]="false"
      [showPersonalSection]="false"
      [showCredentialsSection]="false"
      [showCreateAccessSection]="false"
      [exclude]="['password', 'email']"
      [onUpdate]="reload"
    ></app-form-user>
  </app-admin-form-layout>
}

